import { z } from 'zod';

export const ZodDateLike = z.union([z.string().pipe(z.coerce.date()), z.date()]);

export function createZodDateLike<Type extends z.ZodDate>(type: Type) {
  return z.union([z.string().pipe(z.coerce.date()), type], {
    error: (issue) => {
      if (typeof issue.input === 'string') {
        return 'Expected date, received string';
      }

      return undefined;
    },
  });
}
